import type { RouteRecordRaw } from 'vue-router';

export default {
  path: '',
  name: 'overview',
  component: () => import('@/views/dashboard/overview/overview.vue'),
} satisfies RouteRecordRaw;
